import React  from "react";
import {BrowserRouter as Router, Route , Switch} from 'react-router-dom';
import Items from "./Components/Items";
import Navbar from "./Components/Navbar";
import Cart from "./Components/Cart";
import Home from "./Components/Home";
import Modal from "./Components/Modal";
import Info from "./Components/Info";
import "./App.css";
function App() {
  const highlighter1 = function(){
    document.getElementById("one").classList.add("active");
    document.getElementById("two").classList.remove("active");
    document.getElementById("three").classList.remove("active");
}
const highlighter2 = function(){
    document.getElementById("one").classList.remove("active");
    document.getElementById("two").classList.add("active");
    document.getElementById("three").classList.remove("active");
}
const highlighter3 = function(){
    document.getElementById("one").classList.remove("active");
    document.getElementById("two").classList.remove("active");
    document.getElementById("three").classList.add("active");
}
  return (
    
    <Router>
    <div className="App">
    
      <Navbar/>
      <Switch>
      <Route path="/" exact id="one" onClick={highlighter1} component={Home}/>
      <Route path="/Items" id="two" onClick={highlighter2} component={Items}/>
      <Route path="/Cart" id="three" onClick={highlighter3} component={Cart}/>
      <Route path="/Modal" component={Modal}/>
      <Route path="/Pass" component={Info}/>
      </Switch>
     {/* <footer>
        <p>The Bro-cave 2021 Copyrights<sup>©</sup>.All rights reserved<sup>®</sup>.</p>
     </footer>*/}
    </div>
    </Router>
  );
}

export default App;
